import { IFormatter } from '../FormatterTypes';
import { TEDParseWeek } from '../Parsers/TEDParseWeek';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDDisplayWeek } from '../Displayers/TEDDisplayWeek';

class TEDFormatWeek implements IFormatter {
  displayer = TEDDisplayWeek.getInstance();
  parser = TEDParseWeek.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatWeek };
